import { useEffect, useState, useContext } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import CartContext from "../../context/CartContext";
import { Spinner } from "react-bootstrap";

// Função para formatar imagem
const formatImageUrl = (url) => url.replace('/media/', '/api/media/');

// Função que adiciona 25% ao preço
function calcularDesconto25(preco) {
  const desconto = preco * 0.25;
  return desconto;
}

// ✅ Função que transforma o texto de especificações em lista
const formatEspecificacoes = (texto) => {
  if (!texto) return [];
  return texto
    .split('•') // Divide usando marcador
    .map(item => item.trim()) // Remove espaços
    .filter(item => item.length > 0); // Remove vazios
};

const ProductPage = () => {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const { cart, addToCart } = useContext(CartContext);

  useEffect(() => {
    setLoading(true);
    axios.get(`https://api.nwayami.com/api/produtos/${id}/`)
      .then(response => {
        setProduct(response.data);
        setLoading(false);
      })
      .catch(error => {
        console.error("Erro ao buscar produto:", error);
        setLoading(false);
      });
  }, [id]);

  if (loading) {
    return (
      <div className="text-center mt-5">
        <Spinner animation="border" role="status" />
        <p className="mt-3">Carregando produto, por favor aguarde...</p>
      </div>
    );
  }

  if (!product) return <p className="text-center mt-5">Produto não encontrado.</p>;

  const isInCart = cart && Array.isArray(cart) && cart.some((item) => item.id === product?.id);

  return (
    <div style={{ marginTop: "50px" }}>
      <div className="container mt-5">
        <div className="row">
          <div className="col-md-6">
            <img
              src={formatImageUrl(product.imagem)}
              className="img-fluid"
              alt={product.descricao}
            />
          </div>
          <div className="col-md-6">
            <h2>{product.descricao}</h2>
            <p><strong>Codigo:</strong> {product.codigo}</p>
            <p><strong>Marca:</strong> {product.marca}</p>
            <p><strong>Categoria:</strong> {product.categoria_nome}</p>
            <p><strong>Subcategoria:</strong> {product.subcategoria_nome}</p>

            <p>
              <strong>Preço: </strong>
              KZ{" "}
              {(Number(product.preco_com_iva)+calcularDesconto25(product.preco_com_iva)).toLocaleString("pt-AO", {
                minimumFractionDigits: 2,
              })}
            </p>

            {product.especificacoes && (
            <div className="mt-4" style={{ width: "100%", textAlign: "justify" }}>
            <h5>Especificações:</h5>
            <div>
              {formatEspecificacoes(product.especificacoes).map((item, index) => (
                <p key={index} style={{ marginBottom: "10px", color:"#000" }}>
                 <li>{item}</li> 
                </p>
              ))}
            </div>
          </div>
          
            )}

            <button
              className={`btn ${isInCart ? "btn-secondary" : "btn-success"}`}
              onClick={() => {
                if (isInCart) {
                  alert("Produto já adicionado ao carrinho");
                } else {
                  addToCart(product);
                }
              }}
              disabled={isInCart}
            >
              {isInCart ? "Adicionado ao Carrinho" : "Adicionar ao Carrinho"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductPage;
